import type { RowData } from "@tanstack/react-table";
import { Icon } from "../../icons";
import { cn } from "../../utils";
import { createColumnHelper } from "./column-helper";
import { createMeta } from "./handlers";

/**
 * The expand/collapse column for tables with sub rows, built for the row type the table
 * actually uses — a factory for the same reason `sizeColumns` is one. TanStack's column
 * definitions are invariant in their row type, so a shared constant typed over `any` cannot sit
 * in a `ColumnDef<ArticleListItem>[]` next to the table's own columns.
 */
export function createSubRowHandle<T extends RowData>() {
	const columnHelper = createColumnHelper<T>();

	return columnHelper.display({
		id: "sub-row-handle",
		header: "",
		cell: (cell) => {
			const canExpand = cell.row.getCanExpand();

			/** Render */
			return (
				<button
					type="button"
					className={cn(
						"absolute inset-0 flex-center",
						"focus:input-focused",
						"cursor-pointer",
						"disabled:cursor-not-allowed disabled:opacity-20",
					)}
					disabled={!canExpand}
					onClick={() => {
						if (!canExpand) return;
						cell.row.toggleExpanded(!cell.row.getIsExpanded());
					}}
				>
					<Icon name={cell.row.getIsExpanded() ? "ChevronDown" : "ChevronRight"} />
				</button>
			);
		},
		enableResizing: false,
		enableSorting: false,
		enablePinning: true,
		meta: createMeta({
			isNumeric: false,
			hideOptions: true,
		}),
	});
}
